export const API_HOST =
    process.env.REACT_APP_HOST_API ?? 'http://localhost:8090/';
export const WS_HOST =
    process.env.REACT_APP_HOST_WS ?? 'wss://api.tiler.tehdev.com/ws/';
// export const WS_HOST = process.env.REACT_APP_HOST_WS ?? "ws://localhost:8090/ws/"
export const HOST =
    process.env.REACT_APP_HOST_NAME ??
    window.location.protocol + '//' + window.location.host;
